// extracted by mini-css-extract-plugin
export default {"container":"SettingsCurrent_container__wD5gO","status":"SettingsCurrent_status__nUeDa","config":"SettingsCurrent_config__StY+x"};